var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 2612122"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    rx: 5,
    fill: "#1D4469"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.1963 18.3365C13.4834 18.3365 14.7337 17.9071 15.7491 17.1162L19.58 20.9471C19.8661 21.2234 20.3221 21.2155 20.5985 20.9293C20.8681 20.6502 20.8681 20.2076 20.5985 19.9285L16.7677 16.0976C18.7302 13.5713 18.2732 9.93236 15.7469 7.96981C13.2206 6.00727 9.58165 6.46428 7.61911 8.9906C5.65656 11.5169 6.11357 15.1559 8.63989 17.1184C9.65697 17.9085 10.9084 18.3371 12.1963 18.3365ZM9.11824 9.46674C10.8182 7.76672 13.5744 7.76669 15.2745 9.46667C16.9745 11.1667 16.9745 13.9229 15.2745 15.6229C13.5745 17.3229 10.8183 17.3229 9.11831 15.623C9.11828 15.6229 9.11828 15.6229 9.11824 15.6229C7.41826 13.9353 7.40825 11.1891 9.09584 9.48914C9.1033 9.48165 9.11076 9.47419 9.11824 9.46674Z",
    fill: "#EBF2F7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchBg);
export default __webpack_public_path__ + "static/media/SearchBg.8f01b4a9d593f68d4979b1cd8fe8e5ee.svg";
export { ForwardRef as ReactComponent };